<template>
  <v-content :class="{'landscape': isLandscape(), 'portrait': !isLandscape(), 'large': isLarge(),
                      'xs': $vuetify.breakpoint.xs, 'sm': $vuetify.breakpoint.sm,
                      'md': $vuetify.breakpoint.md, 'lg': $vuetify.breakpoint.lg,
                      'xl': $vuetify.breakpoint.xl}">

    <section class="bg wsp-layout">
      <v-layout row
                wrap
                class="wrapper wsp-padding">
        <v-flex xs12
                lg7>
          <v-layout justify-space-around
                    column
                    fill-height>
            <img :src="require(`@/assets/img/logo.png`)"
                 class="logo">

            <h1 class="display-2 white--text">
              <span :style="{'display:block': !isLandscape()}">{{$t('header.text.1')}}</span>
              <span>{{$t('header.text.2')}}</span>
            </h1>

            <div class="stores">
              <v-layout row
                        wrap
                        justify-center>
                <v-flex xs3>
                  <a href="https://play.google.com/store/apps/details?id=com.wesmartpark.parking"
                     target="_blank">
                    <v-img :src="require(`@/assets/img/google-play-badge-${lang || 'en'}.png`)"></v-img>
                  </a>
                </v-flex>
                <v-flex xs1
                        class="hidden-lg-and-up" />
                <v-spacer class="hidden-md-and-down" />
                <v-flex xs3>
                  <a href="https://itunes.apple.com/es/app/wesmartpark-aparcar-barato/id573568924"
                     target="_blank">
                    <v-img :src="require(`@/assets/img/apple-store-badge-${appleBadge || 'en-GB'}.png`)"></v-img>
                  </a>
                </v-flex>
                <v-flex xs1
                        class="hidden-lg-and-up" />
                <v-spacer class="hidden-md-and-down" />
                <v-flex xs3>
                  <a href="https://appgallery.cloud.huawei.com/ag/n/app/C101270523?channelId=site&id=163e069517e04686b02f8d00b7973422&s=02CA11903D7DF1B04BF3D189381E0FDC71058552C1D62C27E9F412F0C1F9A8F8&detailType=0&v="
                     target="_blank">
                    <v-img :src="require(`@/assets/img/huawei-appgallery-badge-${lang || 'en'}.png`)"></v-img>
                  </a>
                </v-flex>
              </v-layout>
            </div>
          </v-layout>
        </v-flex>
        <v-flex :class="{'hidden-md-and-down':!showPhone()}"
                lg5>
          <img class="phone"
               style="position:absolute"
               :src="require(`@/assets/img/phone-${country || 'ES'}.png`)">
        </v-flex>
      </v-layout>

      <city-boxes></city-boxes>

      <wsp-footer></wsp-footer>
    </section>
  </v-content>
</template>

<script>
import WspFooter from '@/components/WspFooter';
import CityBoxes from '@/components/CityBoxes';
import store from '@/store';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'home',

  components: {
    [WspFooter.name]: WspFooter,
    [CityBoxes.name]: CityBoxes
  },

  metaInfo() {
    return {
      title: this.$i18n.t('page.title'),
      meta: [
        {
          name: 'description',
          content: this.$i18n.t('page.description')
        },
        {
          name: 'keywords',
          content: this.$i18n.t('page.keywords')
        },
        {
          property: 'twitter:title',
          content: this.$i18n.t('meta.twitter.title')
        },
        {
          property: 'twitter:card',
          content: 'photo'
        },
        {
          property: 'twitter:site',
          content: '@wesmartpark'
        },
        {
          property: 'twitter:image',
          content: 'https://www.wesmartpark.com/static/img/share/social.jpg'
        },
        {
          property: 'twitter:url',
          content: window.location.href
        },
        {
          property: 'og:title',
          content: this.$i18n.t('meta.og.title')
        },
        {
          property: 'og:url',
          content: window.location.href
          // content: 'https://smarturl.it/wsp-app'
        },
        {
          property: 'og:site_name',
          content: 'wesmartPark'
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:description',
          content: this.$i18n.t('meta.og.description')
        },
        {
          property: 'og:image',
          content: 'https://www.wesmartpark.com/static/img/share/social.jpg'
        },
        {
          property: 'og:image:alt',
          content: this.$i18n.t('meta.og.image')
        },

        {
          property: 'og:image:width',
          content: '1200'
        },
        {
          property: 'og:image:height',
          content: '586'
        },
        {
          property: 'og:image:type',
          content: 'image/jpeg'
        }
      ]
    };
  },

  data() {
    return {
      country: store.state.country,
      lang: store.state.langSelected.lang,
      appleBadge: store.state.langSelected.appleBadge
    };
  },
  mounted() {
    EventBus.$emit(keys.countrySelected, {});
  },
  methods: {
    isLandscape() {
      return this.$vuetify.breakpoint.height < this.$vuetify.breakpoint.width;
    },

    isLarge() {
      return this.$vuetify.breakpoint.height > 650;
    },

    showPhone() {
      return this.isLandscape() && this.$vuetify.breakpoint.lgAndUp;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue